module.exports = __webpack_public_path__ + "img/073480.ddb71fe8.png";